const SCHEME_WITHOUT_SLASHES = /^(https?):(?!\/\/)/i;
const HTTP_PROTOCOLS = new Set(['http:', 'https:']);

function toOriginOrHref(parsed: URL): string {
  if (
    (parsed.pathname === '/' || parsed.pathname === '') &&
    !parsed.search &&
    !parsed.hash
  ) {
    return parsed.origin;
  }
  return parsed.href;
}

function fromFallbackDomain(fallbackDomain?: string): string {
  if (!fallbackDomain) return '';
  try {
    return toOriginOrHref(new URL(`https://${fallbackDomain}`));
  } catch {
    return '';
  }
}

/**
 * Repair a public site origin used for canonical URLs.
 *
 * `https:host` (missing `//`) is not a valid absolute URL. Insert `//` after
 * the scheme. Hostname policy (`www` vs apex) stays on tenant-config
 * `urls.main` — this helper does not add `www.`. Already-valid URLs are left
 * alone. Non-http(s) values fail closed to `https://{fallbackDomain}` when
 * provided.
 */
export function normalizeSiteUrl(
  raw: string | undefined | null,
  fallbackDomain?: string,
): string {
  const trimmed = (raw ?? '').trim();
  const candidate = trimmed.replace(SCHEME_WITHOUT_SLASHES, '$1://');

  let parsed: URL | null = null;
  if (candidate) {
    try {
      parsed = new URL(candidate);
    } catch {
      parsed = null;
    }
  }

  if (!parsed?.hostname || !HTTP_PROTOCOLS.has(parsed.protocol)) {
    return fromFallbackDomain(fallbackDomain);
  }

  return toOriginOrHref(parsed);
}
